/* global axios */
import ApiClient from './ApiClient';

const appendValue = (formData, key, value) => {
  if (value === undefined || value === null) return;
  if (Array.isArray(value)) {
    value.forEach(item => formData.append(`${key}[]`, item));
    return;
  }
  if (typeof value === 'object') {
    Object.entries(value).forEach(([child, nested]) => {
      appendValue(formData, `${key}[${child}]`, nested);
    });
    return;
  }
  formData.append(key, value);
};

const recontactBody = (schedule, file) => {
  if (!file) return { whatsapp_recontact_schedule: schedule };
  const formData = new FormData();
  appendValue(formData, 'whatsapp_recontact_schedule', schedule);
  formData.append('whatsapp_recontact_schedule[header_media]', file);
  return formData;
};

class WhatsappRecontactAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  list(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_recontact_schedules`);
  }

  show(inboxId, scheduleId) {
    return axios.get(
      `${this.url}/${inboxId}/whatsapp_recontact_schedules/${scheduleId}`
    );
  }

  create(inboxId, schedule, file) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_recontact_schedules`,
      recontactBody(schedule, file)
    );
  }

  update(inboxId, scheduleId, schedule, file) {
    return axios.patch(
      `${this.url}/${inboxId}/whatsapp_recontact_schedules/${scheduleId}`,
      recontactBody(schedule, file)
    );
  }

  delete(inboxId, scheduleId) {
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_recontact_schedules/${scheduleId}`
    );
  }
}

export default new WhatsappRecontactAPI();
